module.exports = __webpack_public_path__ + "static/0034-9fc2804788ff443bb73297d745801e93.png";